import React, { useEffect, useState } from 'react'
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import { getProfileAddressDetails, getProfileDetails, insertProfileAddressInfo, insertContactInfo, addProfileAddressDetails, updateContactInfo, deleteAddressData, updateChangePassword, updateProfileAddressDetails, updateProfileDetails, updateProfileAddressInfo, UserTradeInfo, getProfileSecondaryEmailDetails, deleteContactDetail, getProfileAddressDetailsByIndex } from "../../../services/myAccountService";
import EditIcon from '@material-ui/icons/Edit'
import {  addAddressData , AddressData} from "../../../services/addressService";
import * as actions from '../../../store/actions/cart';
import Stepper from '../../Stepper/index';
import Button from 'react-bootstrap/Button';
import { isEmpty } from '../../../validation';
import Skeleton from 'react-loading-skeleton';
import swal from 'sweetalert';
import { postalCode } from '../../../validation/validation';

const defaultUserName = {
    firstName: '',
    lastName: '',
    username: '',
    email: '',
    pk: ''
  }
const defaultAddress = {
    firstName: '',
    lastName: '',
    addressType: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zipcode: '',
    primaryAddress: '',
    addressType: '',
    id: ''
  } 
const AddressPage = (props) => {
const [addList, setAddList] = useState([])
const [isLoaderAddAddress, setIsLoaderAddAddress] = useState(false)
const [isLoaderAddress, setIsLoaderAddress] = useState(false)
const [isEditAddressByIndex, setIsEditAddressByIndex] = useState(null)
const [isAddAnotherAddress, setIsAddAnotherAddress] = useState(false)
const [address, setAddress] = useState()
const [staticAddress, setStaticAddress] = useState(defaultAddress)
const [isAddAddress, setIsAddAddress] = useState(false)
const [userName, setUserName] = useState(defaultUserName)
const [selectedAddress, setSelectedAddress]= useState(null)
const [radioDisable, setRadioDisable] = useState(null)

    const previousPage = () => {
        if (props.totalPayment >= 1) {
           props.history.push("/cart/payment")
        } else {
            props.history.push("/cart")
        }
    }

    const  handleSubmit = (value) => {
        const obj = {
            addType:value.addType,
            firstName:value.firstName,
            lastName:value.lastName,
            addressLine1: value.addressLine1,
            addressLine2: value.addressLine2,
            city: value.city,
            state: value.state,
            zipcode: value.zip,
            primaryAddress: false
        }
        console.log(obj)
        if (props.token) {
            addAddressData(obj).then(
                (res) => {
                    value.addressId = res.data.id
                    props.addAddress(value)
                    console.log(obj)
                    props.history.push("/cart/checkout");
                }
            ).catch(err => {
                console.log(err);
            })
        } else {
            props.addAddress(value)
            props.history.push("/cart/checkout");
        }
        
    };
  
  const NextPage = (value) => {
    
            console.log(value.selectedAddress)
            props.addAddress(address[value.selectedAddress])
            console.log(address[value.selectedAddress])
            props.history.push("/cart/checkout");
  
}
const validation=
Yup.object().shape({
  selectedAddress: Yup.string()
      .required("Please select atleast one address or add new address"),
            
        });

  const handleReset =(resetForm) =>{
  resetForm();
}
    useEffect(() => {
        getProfileData();
      }, []);
      useEffect(() => {
       props.history.push("/cart/address");
      }, [props.token]);
    
      const getProfileData = () => {
        getProfileDetails().then(
          (res) => {
            if (!isEmpty(res.data)) {
              
              setUserName({
                firstName: res.data.first_name,
                lastName: res.data.last_name,
                username: res.data.username,
                email: res.data.email,
                pk: res.data.pk
              })
              getProfileAddress(res.data.pk);
              
            }
          }
        ).catch(err => {
          console.log(err);
        })
      }
    const getProfileAddress = (id) => {
        getProfileAddressDetails(id).then(res => {
          if (!isEmpty(res.data.results)) {
            setIsAddAddress(true)
            setAddress(res.data.results)
          } else {
            setIsAddAddress(false)
          }
        }).catch(err => {
          console.log(err);
        })
      }
    const addAddress = () => {
        setIsAddAddress(true)
        if (!address) {
          setIsAddAnotherAddress(true)
        }
      }
    const editAddressByIndex = (index) => {
        setIsEditAddressByIndex(index)
      }
    const primaryAddress = async (index, address, value) => {
        if (address[index].id != value.id && address[index].primaryAddress === true) {
          const data = { ...address[index], primaryAddress: false }
          await updateProfileAddressInfo(data).then((res) => {
          })
        }
      }
      const addAddressHandleSubmit = async (value) => {
        
        setIsLoaderAddAddress(true)
       
        if (value.primaryAddress === true) {
          for (var i in address) {
            console.log("this is working")
            const data = { ...address[i], primaryAddress: false }
            await updateProfileAddressInfo(data).then((res) => {
              if(res){console.log("this is working")}
            })
          }
          
        }
        insertProfileAddressInfo(value).then((res) => {
          
          
          
            
            window.location.reload()
            setIsAddAnotherAddress(false)
            setIsLoaderAddAddress(false)
         
          
        })
       
      }
    const Disable =(index) =>{
      if(index!==null){
        return true
      }else if(index === undefined){
        return false
      }else 
      {
        return false
      }
      
    }
    const changeAddressHandleSubmit = async (value) => {
            
            setIsLoaderAddress(true)
            if (value.primaryAddress === true) {
              for (var i in address) {
                await primaryAddress(i, address, value)
              }
            }
            updateProfileAddressInfo(value).then((res) => {
            setTimeout(() => {
              setIsLoaderAddress(false)
              setIsEditAddressByIndex(null)
            }, 3000);
            window.location.reload()
          })
        }
        const deleteAddressByIndex = (item) => {
            swal({
              title: "Are you sure?",
              text: "Want to deleted address",
              icon: "warning",
              buttons: true,
              dangerMode: true,
            })
              .then((willDelete) => {
                if (willDelete) {
              
                  deleteAddressData(item.id).then(
                    (res) => {
                      setAddress();
                      window.location.reload()
                     
                     
                    }
                  ).catch(err => {
                    console.log(err);
                  })
                }
              });
          }
    const addressSchema = Yup.object().shape({
        firstName: Yup.string()
            .required('Please input your first name!'),
        lastName: Yup.string()
            .required('Please input your last name!'),
       
        addressLine1: Yup.string()
            .required('Please input your address line1!'),
       
        city: Yup.string()
            .required('Please input your city!'),
        state: Yup.string()
            .required('Please input your province'),
        zip: Yup.string()
            .matches(postalCode, "Please enter valid postal code")
            .required('Please input your postal code!'),
        country: Yup.string()
            .required('Please input your country!'),
    });

    const changeAddressSchema = Yup.object().shape({
        
        addressLine1: Yup.string()
          .required('Please input your Address Line 1'),
        firstName: Yup.string()
          .required('Please input your First Name!'),
        lastName: Yup.string()
          .required('Please input your Last Name!'),
       
        city: Yup.string()
          .required('Please input your city!'),
        state: Yup.string()
          .required('Please input your province!'),
        zipcode: Yup.string()
          .matches(postalCode, "Please enter valid postal code")
          .required('Please input your postal code!'),
         
      });
    
    useEffect(() => {
        if (isEmpty(props.items)) {
            props.history.push("/cart");
        }
    });

    const initialValues = {
        firstName: props.address.firstName ? props.address.firstName : "",
        lastName: props.address.lastName ? props.address.lastName : "",
        addType: props.address.addType ? props.address.addType : "",
        addressLine1: props.address.addressLine1 ? props.address.addressLine1 : "",
        addressLine2: props.address.addressLine2 ? props.address.addressLine2 : "",
        city: props.address.city ? props.address.city : "",
        state: props.address.state ? props.address.state : "",
        zip: props.address.zip ? props.address.zip : "",
        country: 'CANADA'
    }

    return (
      <div className='container'>
        <div className='container-3'>
            <div>
                {
                    props.totalPayment >= 1 &&
                    <Stepper steps={[{ title: "Cart" }, { title: "Payment" }, { title: "Address" }, { title: "Checkout" }]} activeStep={2} />
                }
                {
                    props.totalPayment === 0 &&
                    <Stepper steps={[{ title: "Cart" }, { title: "Address" }, { title: "Checkout" }]} activeStep={1} />

                }
                
            </div>
            <hr></hr>
            
              <Formik
                    initialValues={staticAddress}
                    onSubmit={addAddressHandleSubmit}
                    validationSchema={changeAddressSchema}
                    render={({ values }) => (
                      <Form className="w-100">
                       
                          {isAddAnotherAddress && !isLoaderAddAddress && 
                          <div className='`border bg-white rounded-lg p-3  mt-2'>
                           
                            <div className="mt-4 text-center" >
                              <label className="ml-1">
                                <span style={{fontSize:15, fontWeight:600}}>
                                  Adding Address...
                                </span>
                              </label>
                            </div>
                            <div>
                              <label className="col-md-10 mt-3 p-1">
                              <span className='text-danger'>*</span>First Name :
                                </label>
                              <div className="col-md-6 p-1">
                                <Field className="form-control" type="text" name="firstName" />
                                <ErrorMessage name="firstName" className="text-danger" component="div" />
                              </div>
                            </div>
                            <div>
                              <label className="col-md-10 mt-3 p-1">
                              <span className='text-danger'>*</span>Last Name :
                                </label>
                              <div className="col-md-6 p-1">
                                <Field className="form-control" type="text" name="lastName" />
                                <ErrorMessage name="lastName" className="text-danger" component="div" />
                              </div>
                            </div>

                            <div>
                              <label className="col-md-10 mt-3 p-1">
                                Address Type  :
                                </label>
                              <div className="col-md-6 p-1">
                                <Field className="form-control" type="text" name="addressType" placeholder="Ex.Home, Office, etc."/>
                                <ErrorMessage name="addressType" className="text-danger" component="div" />
                              </div>
                            </div>

                            <div>
                              <label className="col-md-10 mt-2 p-1">
                              <span className='text-danger'>*</span>Address Line1 :
                                </label>
                              <div className="col-md-6 p-1">
                                <Field className="form-control" type="text" name="addressLine1" />
                                <ErrorMessage name="addressLine1" className="text-danger" component="div" />
                              </div>
                            </div>

                            <div>
                              <label className="col-md-10 mt-2 p-1">
                                Address Line2 :
                                </label>
                              <div className="col-md-6 p-1">
                                <Field className="form-control" type="text" name="addressLine2" />
                                <ErrorMessage name="addressLine2" className="text-danger" component="div" />
                              </div>
                            </div>

                            <div>
                              <label className="col-md-10 mt-2 p-1">
                              <span className='text-danger'>*</span>City  :
                                </label>
                              <div className="col-md-6 p-1">
                                <Field className="form-control" type="text" name="city" />
                                <ErrorMessage name="city" className="text-danger" component="div" />
                              </div>
                            </div>

                            <div>
                              <label className="col-md-10 mt-2 p-1">
                              <span className='text-danger'>*</span>Province   :
                                </label>
                              <div className="col-md-6 p-1">
                              <Field  component="select" className="form-control" type="text" name="state" >
                                            <option selected='true'>Choose a Province...</option>
                                            <option value="AB">AB</option>
                                            <option value="BC">BC</option>
                                            <option value="MB">MB</option>
                                            <option value="NB">NB</option>
                                            <option value="NL">NL</option>
                                            <option value="NS">NS</option>
                                            <option value="ON">ON</option>
                                            <option value="PE">PE</option>
                                            <option value="QC">QC</option>
                                            <option value="SK">SK</option>
                                           
                                          </Field>
                                          <ErrorMessage name="state" className="text-danger" component="div" />
                              </div>
                            </div>

                            <div>
                              <label className="col-md-10 mt-2 p-1">
                              <span className='text-danger'>*</span> Postal Code :
                                </label>
                              <div className="col-md-4 p-1">
                                <Field className="form-control" type="text" name="zipcode" />
                                <ErrorMessage name="zipcode" className="text-danger" component="div" />
                              </div>
                            </div>

                            <div>
                              <label className="col-md-10 mt-2 p-1">
                                Primary Address :
                                <Field className="ml-2" type="checkbox" name="primaryAddress" />
                              </label>

                            </div>

                            <div className="mt-2 mb-3">
                              <button type="submit" className="btn btn-dark mr-2" >
                                Save Address
                               </button>
                              <button type="reset" className="btn btn-dark mr-2" >
                                Reset
                               </button>
                              <button className="btn btn-dark mr-2" onClick={() => setIsAddAnotherAddress(false)}>
                                Cancel
                               </button>
                            </div>
                            
                            

                          </div>}
                        
                      </Form>
                    )}
                  />
           {
                isAddAddress && !isAddAnotherAddress&&
                <div className='container-3'>
                {
                <div className='text-center'>
                  <div>
                  <span style={{fontSize:15, fontWeight:700}}className='ml-2'>Select existing address </span> 
                
                <br></br><strong>OR</strong> 
                  </div>
                 
                    
                    <Button className="border-dark" position="center" onClick={() => 
                    (setIsAddAnotherAddress(true),
                    setIsEditAddressByIndex(null))}  variant=""><svg width="2em" height="2em" viewBox="0 0 16 16" className="bi bi-plus-circle-fill mr-2 mt-1" fill="currentColor" xmlns="http://www.w3.org/2000/svg" onClick={() => 
                      (setIsAddAnotherAddress(true),
                      setIsEditAddressByIndex(null))}>
                          <path fill-rule="evenodd" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4a.5.5 0 0 0-1 0v3.5H4a.5.5 0 0 0 0 1h3.5V12a.5.5 0 0 0 1 0V8.5H12a.5.5 0 0 0 0-1H8.5V4z" />
                      </svg>Add new address</Button>
                

                </div>
                }
                
                  
                  {address && address.length > 0 &&
                 <Formik
                 initialValues={{selectedAddress: ""}}
               
                onSubmit={NextPage}validationSchema={validation}
                >
                    {({ isSubmitting, values }) => (

                <Form>

                   
                   { address.map((item, index) => (
                     
                     <div className='container-3'style={{fontSize :"15px", }}>

                        {
                          isLoaderAddress && isEditAddressByIndex === index &&
                          <Skeleton count={6} duration={2} height={68} />
                        }

                        {isEditAddressByIndex !== index && (isLoaderAddress && isEditAddressByIndex === index ? false : true) &&
                          <div className=''>
                          <div className={`border bg-white rounded-lg p-3  mt-2 ${selectedAddress === index  && 'border border-dark' || ''}`} >
                                                            
                          <Field className="mx-2 my-2" id={index} value={`${index}`} name="selectedAddress" type="radio" onClick={()=>(setSelectedAddress(index))}  />
                            {item.primaryAddress && 
                              <div className="border rounded-lg  bg-success d-flex justify-content-center" >
                                <label className="ml-1 mt-2 h7">
                                   Primary Address
                                </label>
                              </div>
                            }
                            <div className='font-weight-light' style={{fontSize :"14px"}}>
                          <div className=''>
                            {item.addType &&
                              <div>
                              <label >
                                <strong>Address Type  : </strong><span>{item.addressType}</span>
                              </label>
                            </div>
                            }
                             {item.firstName && item.lastName &&
                              <div className='mt-2'>
                              <label >
                                {item.firstName} {item.lastName}
                              </label>
                            </div>
                            }
                            <div>
                              <label >
                                {item.addressLine1}<br></br>
                                {item.addressLine2},<br></br>{item.state} {item.zipcode}
                              </label>
                            </div>
                            </div>
                           
                            <div>
                              <button type="submit" className="  bg-light text-dark" onClick={() => {
                                setIsAddAnotherAddress(false)
                                editAddressByIndex(index)
                              }}>
                                <div className='d-left'>
                                <EditIcon/>
                                </div>
                                
                              </button>
                              <span className="float-right text-danger mt-2 cursor-pointer" onClick={() => deleteAddressByIndex(item)}><svg width="3em" height="3em" viewBox="0 0 16 16" className="bi bi-trash" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                <path fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                            </svg></span>
                           
                            </div>
                            </div>
                           </div> 
                          </div>
                         
                          
                        }

                        {isEditAddressByIndex === index && (isLoaderAddress && isEditAddressByIndex === index ? false : true) &&
                        <div className="border bg-white rounded-lg p-3" >

                         <Formik
                            initialValues={item}
                            onSubmit={changeAddressHandleSubmit}
                            validationSchema={changeAddressSchema}
                          
                            render={({ values }) => (
                              <Form>
                                <div>
                                  <label className="col-md-10 mt-3 p-1">
                                  Address Type  :
                                  </label>
                                  <div className="col-md-6 p-1">
                                    <Field className="form-control" type="text" name="addressType" />
                                    <ErrorMessage name="addressType" className="text-danger" component="div" />
                                  </div>
                                </div>
                                <div>
                                  <label className="col-md-10 mt-3 p-1">
                                  <span className='text-danger'>*</span>First Name :
                                  </label>
                                  <div className="col-md-6 p-1">
                                    <Field className="form-control" type="text" name="firstName" />
                                    <ErrorMessage name="firstName" className="text-danger" component="div" />
                                  </div>
                                </div>
                                <div>
                                  <label className="col-md-10 mt-3 p-1">
                                  <span className='text-danger'>*</span>Last Name :
                                  </label>
                                  <div className="col-md-6 p-1">
                                    <Field className="form-control" type="text" name="lastName" />
                                    <ErrorMessage name="lastName" className="text-danger" component="div" />
                                  </div>
                                </div>

                                <div>
                                  <label className="col-md-10 mt-2 p-1">
                                  <span className='text-danger'>*</span>Address Line 1 :
                                  </label>
                                  <div className="col-md-6 p-1">
                                    <Field className="form-control" type="text" name="addressLine1" />
                                    <ErrorMessage name="addressLine1" className="text-danger" component="div" />
                                  </div>
                                </div>

                                <div>
                                  <label className="col-md-10 mt-2 p-1">
                                    Address Line 2 :
                                  </label>
                                  <div className="col-md-6 p-1">
                                    <Field className="form-control" type="text" name="addressLine2" />
                                    <ErrorMessage name="addressLine2" className="text-danger" component="div" />
                                  </div>
                                </div>

                                <div>
                                  <label className="col-md-10 mt-2 p-1">
                                  <span className='text-danger'>*</span>City  :
                                  </label>
                                  <div className="col-md-6 p-1">
                                    <Field className="form-control" type="text" name="city" />
                                    <ErrorMessage name="city" className="text-danger" component="div" />
                                  </div>
                                </div>

                                <div>
                                  <label className="col-md-10 mt-2 p-1">
                                  <span className='text-danger'>*</span>Province  :
                                  </label>
                                  <div className="col-md-6 p-1">
                                  <Field  component="select" className="form-control" type="text" name="state" >
                                            <option selected='true'>Choose a Province...</option>
                                            <option value="AB">AB</option>
                                            <option value="BC">BC</option>
                                            <option value="MB">MB</option>
                                            <option value="NB">NB</option>
                                            <option value="NL">NL</option>
                                            <option value="NS">NS</option>
                                            <option value="ON">ON</option>
                                            <option value="PE">PE</option>
                                            <option value="QC">QC</option>
                                            <option value="SK">SK</option>
                                           
                                          </Field>
                                          <ErrorMessage name="state" className="text-danger" component="div" />
                                  </div>
                                </div>

                                <div>
                                  <label className="col-md-10 mt-2 p-1">
                                  <span className='text-danger'>*</span>Postal Code :
                                   </label>
                                  <div className="col-md-4 p-1">
                                    <Field className="form-control" type="text" name="zipcode" />
                                    <ErrorMessage name="zipcode" className="text-danger" component="div" />
                                  </div>
                                </div>

                                <div>
                                  <label className="col-md-10 mt-2 p-1">
                                    Primary Address :
                                  <Field className="ml-2" type="checkbox" name="primaryAddress" />
                                  </label>

                                </div>

                                <div className="mt-2">
                                  <button type="submit" className="btn btn-dark mr-2">
                                    Save Address
                                  </button>
                                  {/*<button type="reset" className="btn btn-dark mr-2" >
                                    Reset
                                  </button>*/}
                                  <button className="btn btn-dark mr-2" onClick={() => setIsEditAddressByIndex()}>
                                    Cancel
                                  </button>
                                </div>
                              </Form>
                            )}
                          />
                          </div> 
                      }
                      
                    </div>
                    ))
                    }
                     <ErrorMessage name="selectedAddress" className="text-danger ml-3" component="div" />

                     <div className=" mt-4 ml-1 mb-4">
                            <div className="mt-4 d-flex">
                                <Button className="w-100 bg-warning border-dark ml-2" onClick={previousPage} variant=""><span style={{fontSize:20, fontWeight:800}}>Previous</span></Button>
                                <Button className="w-100 bg-warning border-dark ml-4" type="submit" disabled={isSubmitting} variant=""><span style={{fontSize:20, fontWeight:800}}>Next</span></Button>
                            </div>
                        </div>
              
                    </Form>)}
                    </Formik>
                  }

                
                 
                
                  {isLoaderAddAddress &&
                    <Skeleton count={6} duration={2} height={68} />
                  }
                  
                        </div>
              }
            
            

      { !isAddAddress &&
      <>
           <div className=" ml-3">
                <h6>Enter your address to process your order </h6>
                <p className='text-danger' style={{fontSize:"13px"}}>*If you have selected payment method Cash, since you are meeting our associate in person,
                    <br></br>kindly enter the address of the public place near you where you can meet us.</p>
            </div>
        
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                validationSchema={addressSchema}
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                value={props.values}
            >
                {({ isSubmitting }) => (
                    <Form>
                      <div className=''>
                      <div className="row ml-2">
                            <div className="col-md-8">
                                <div className="d-flex">
                                    <div className="">
                                      
                                        <label className="col-md-12 mt-1">
                                        <span className='text-danger'>*</span>  First Name:
                                       </label>
                                        <div className="col-md-12">
                                            <Field className="form-control" type="text" name="firstName" />
                                            <ErrorMessage name="firstName" className="text-danger" component="div" />
                                        </div>
                                    </div>
                                    <div className="">
                                        <label className="col-md-12 mt-1">
                                        <span className='text-danger'>*</span>Last Name:
                                    </label>
                                        <div className="col-md-12">
                                            <Field className="form-control" type="text" name="lastName" />
                                            <ErrorMessage name="lastName" className="text-danger" component="div" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-8">
                                <label className="col-md-12 mt">
                                    Address type:
                                 </label>
                                <div className="col-md-10">
                                    <Field className="form-control" type="text" name="addType"  placeholder="Ex. Office, Home etc.(For local meetup,Ex.Walmart,Tim Horton)"/>
                                    <ErrorMessage name="addType" className="text-danger" component="div" />
                                </div>
                            </div>
                            <div className="col-md-8">
                                <label className="col-md-12 mt">
                                <span className='text-danger'>*</span>Address Line1:
                                 </label>
                                <div className="col-md-10">
                                    <Field className="form-control" type="text" name="addressLine1"  placeholder="ex. 123 Main st"/>
                                    <ErrorMessage name="addressLine1" className="text-danger" component="div" />
                                </div>
                            </div>
                            <div className="col-md-8">
                                <label className="col-md-12 mt">
                                    Address Line2:
                                 </label>
                                <div className="col-md-10">
                                    <Field className="form-control" type="text" name="addressLine2" placeholder="Apt/Suite/Unit #"/>
                                    <ErrorMessage name="addressLine2" className="text-danger" component="div" />
                                </div>
                            </div>
                           
                            <div className="col-md-8">
                                <div className="d-flex">
                                    <div className="">
                                        <label className="col-md-12 mt">
                                        <span className='text-danger'>*</span>City:
                                    </label>
                                        <div className="col-md-12">
                                            <Field className="form-control" type="text" name="city" />
                                            <ErrorMessage name="city" className="text-danger" component="div" />
                                        </div>
                                    </div>
                                    <div className="">
                                        <label className="col-md-12 mt">
                                        <span className='text-danger'>*</span> Province:
                                    </label>
                                        <div className="col-md-12">
                                        <Field  component="select" className="form-control" type="text" name="state" >
                                            <option selected='true'>Choose a Province...</option>
                                            <option value="AB">AB</option>
                                            <option value="BC">BC</option>
                                            <option value="MB">MB</option>
                                            <option value="NB">NB</option>
                                            <option value="NL">NL</option>
                                            <option value="NS">NS</option>
                                            <option value="ON">ON</option>
                                            <option value="PE">PE</option>
                                            <option value="QC">QC</option>
                                            <option value="SK">SK</option>
                                           
                                          </Field>
                                          <ErrorMessage name="state" className="text-danger" component="div" />
                                            
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="d-flex">
                                    <div style={{marginLeft:""}} className="">
                                        <label className="col-md-10">
                                        <span className='text-danger'>*</span>Postal Code:
                                        </label>
                                        <div className="col-md-10">
                                            <Field className="form-control" type="text" name="zip" />
                                            <ErrorMessage name="zip" className="text-danger" component="div" />
                                        </div>
                                    </div>
                                    <div className="mr-4 mt-3">
                                        <label className="col-md-8 ">
                                        <span className="h7">Canada </span>
                                        </label>
                                        
                                    </div>
                                </div>
                             </div>
                             <span className='text-danger mt-2'>Currently we are only operational in canada.</span>
                          </div>
                      </div>
                     
                      
                        


                        <div className=" mt-4 ml-1 mb-4">
                            <div className="mt-4 d-flex">
                                <Button className="w-100 bg-warning border-dark ml-2" onClick={previousPage} variant=""><span style={{fontSize:20, fontWeight:800}}>Previous</span></Button>
                                <Button className="w-100 bg-warning border-dark ml-4" type="submit" disabled={isSubmitting} variant=""><span style={{fontSize:20, fontWeight:800}}>Next</span></Button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
            </>
      }
        </div>
      </div>
      
        
    )

}


const mapStateToProps = state => {
    return {
        address: state.cart.address,
        items: state.cart.items,
        token: state.auth.token,
        totalPayment: state.cart.totalPayment
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addAddress: (value) => dispatch(actions.updateCartAddress(value))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddressPage);
